// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основные стили */
.pf-performance-section {
  min-height: 50vh;
  background: white;
  font-family: 'Montserrat', sans-serif !important;
  color: #1f2937;
}

/* Загрузка */
.pf-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  color: #002FA7;
}

.pf-loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 47, 167, 0.3);
  border-left: 4px solid #002FA7;
  border-radius: 50%;
  animation: pf-spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes pf-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.pf-loading p {
  font-size: 18px;
  margin: 0;
}

/* Навигация */
.pf-nav {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 30px;
}

.pf-nav-btn {
  padding: 15px 30px;
  border: none;
  border-radius: 15px;
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1em;
  width: 30%;
}

.pf-nav-btn:hover {
  background: rgba(0, 47, 167, 0.2);
  transform: translateY(-2px);
}

.pf-nav-btn.pf-active {
  background: #002FA7;
  color: white;
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.3);
}

/* Кнопка обновления */
.pf-refresh-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.pf-refresh-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.pf-refresh-btn:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.pf-refresh-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.pf-refresh-spin {
  animation: pf-spin 1s linear infinite;
}

/* Контролы */
.pf-controls-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  margin-left: 34px;
  flex-wrap: wrap;
}

.pf-controls-section-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-right: 34px;
  flex-wrap: wrap;
}

/* Селектор семестра */
.pf-semester-selector {
  display: flex;
  gap: 10px;
}

.pf-semester-buttons {
  display: flex;
  background: rgba(0, 47, 167, 0.1);
  border-radius: 15px;
  padding: 5px;
  gap: 5px;
}

.pf-semester-btn {
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #6c757d;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pf-semester-btn.pf-active {
  background: white;
  color: #002FA7;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);
}

/* Переключение вида */
.pf-view-toggle {
  display: flex;
  background: rgba(0, 47, 167, 0.1);
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
}

.pf-toggle-btn {
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #6c757d;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pf-toggle-btn.pf-active {
  background: white;
  color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);
}

/* Основной контент */
.pf-content {
  padding: 0 25px 25px;
}

.pf-tab-content {
  animation: pf-fadeIn 0.5s ease;
}

@keyframes pf-fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Сетка предметов */
.pf-subjects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.pf-subject-card {
  background: white;
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-subject-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 47, 167, 0.3);
}

.pf-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.pf-subject-title {
  margin: 0;
  font-size: 1.3em;
  font-weight: 600;
  color: #2d3748;
  line-height: 1.3;
  text-align: left;
}

/* Общие стили для оценок */
.pf-preview-grade,
.pf-stack-grade,
.pf-grade-value,
.pf-session-grade,
.pf-grade-value-small,
.pf-grade-change-value {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.pf-preview-grade,
.pf-grade-value,
.pf-session-grade,
.pf-grade-value-small {
  width: 35px;
  height: 35px;
  border-radius: 10px;
  font-size: 0.9em;
}

.pf-stack-grade {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 0.85em;
}

.pf-preview-grade:hover,
.pf-stack-grade:hover,
.pf-grade-value:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.pf-preview-grade.pf-no-data,
.pf-stack-grade.pf-no-data,
.pf-grade-value.pf-no-data,
.pf-grade-value-small.pf-no-data {
  background-color: #d1d5db !important;
}

.pf-grades-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
  min-height: 40px;
  align-items: center;
}

.pf-more-grades {
  background: #e2e8f0;
  color: #64748b;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 0.8em;
  font-weight: 500;
}

.pf-no-grades,
.pf-no-data-text {
  color: #a0aec0;
  font-style: italic;
  font-size: 0.9em;
}

/* Футер карточки */
.pf-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #e2e8f0;
}

.pf-average-score {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pf-average-label {
  font-size: 0.9em;
  color: #718096;
}

.pf-average-value {
  font-weight: 700;
  font-size: 1.1em;
}

/* Таблица предметов */
.pf-subjects-table-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-subjects-table {
  width: 100%;
  border-collapse: collapse;
}

.pf-subjects-table th {
  background: rgba(0, 47, 167, 0.05);
  padding: 20px;
  text-align: left;
  font-weight: 600;
  color: #4a5568;
  border-bottom: 1px solid #e2e8f0;
}

.pf-subjects-table td {
  padding: 20px;
  border-bottom: 1px solid #f7fafc;
}

.pf-subjects-table tr:hover {
  background: rgba(0, 47, 167, 0.02);
}

.pf-subject-cell {
  width: 25%;
  text-align: left;
}

.pf-subject-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pf-subject-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 1rem;
}

.pf-subject-teacher {
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
}

.pf-grades-cell {
  width: 45%;
}

.pf-grades-stack {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pf-average-cell {
  width: 15%;
}

.pf-average-badge {
  padding: 8px 16px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.9em;
  text-align: center;
  min-width: 60px;
}

.pf-session-cell {
  width: 15%;
}

.pf-session-grade {
  margin: 0 auto;
}

/* Аналитика */
.pf-analytics-container {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-analytics-top-row {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  align-items: stretch;
}

.pf-chart-half {
  flex: 2 1;
  min-width: 0;
}

/* Карточки статистики */
.pf-stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.pf-stats-vertical {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 0;
}

.pf-stat-card {
  background: rgba(0, 47, 167, 0.08);
  color: #002FA7;
  padding: 25px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);
  background: rgba(0, 47, 167, 0.12);
}

.pf-stat-content {
  text-align: center;
}

.pf-stat-content .pf-stat-value {
  font-size: 2.5em;
  font-weight: 700;
  margin: 0;
  line-height: 1;
  color: #002FA7;
}

.pf-stat-content .pf-stat-label {
  font-size: 1em;
  color: #002FA7;
  margin: 8px 0 0 0;
  font-weight: 500;
  opacity: 0.9;
}

/* Графики */
.pf-charts-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-top: 20px;
}

.pf-chart-card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 47, 167, 0.1);
  max-width: 100%;
}

.pf-chart-card h3 {
  margin: 0 0 25px 0;
  color: #2d3748;
  font-size: 1.3em;
  font-weight: 600;
  text-align: center;
}

.pf-chart-card p {
  color: #a8aaad;
  font-size: 10px;
  margin: 0;
}

/* Детали предмета */
.pf-subject-detail-container {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-subject-selector {
  margin-bottom: 30px;
}

.pf-select {
  width: 100%;
  padding: 15px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1em;
  background: white;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pf-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.pf-detail-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f7fafc;
}

.pf-detail-header h2 {
  margin: 0 0 15px 0;
  color: #2d3748;
  font-size: 1.8em;
  font-weight: 700;
}

.pf-subject-meta {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.pf-meta-item {
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9em;
  font-weight: 500;
}

/* Состояние без выбранного предмета */
.pf-no-subject-selected,
.pf-no-data-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
}

.pf-empty-state {
  text-align: center;
  padding: 2rem;
  max-width: 400px;
}

.pf-empty-state h3 {
  color: #64748b;
  margin-bottom: 0.5rem;
}

.pf-empty-state p {
  color: #94a3b8;
  margin-bottom: 1rem;
  font-size: 1.1em;
}

/* Попап */
.pf-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: pf-modal-fade-in 0.3s ease;
  backdrop-filter: blur(4px);
}

@keyframes pf-modal-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.pf-popup-large {
  background: white;
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: pf-scaleIn 0.3s ease;
}

@keyframes pf-scaleIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

.pf-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 40px 20px;
  border-bottom: 1px solid rgba(0, 47, 167, 0.1);
  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
  border-radius: 20px 20px 0 0;
}

.pf-popup-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 1.5rem;
  font-weight: 600;
}

.pf-popup-close {
  background: rgba(0, 47, 167, 0.1);
  border: none;
  border-radius: 4px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #002FA7;
  font-size: 28px;
  font-weight: 300;
}

.pf-popup-close:hover {
  background: rgba(0, 47, 167, 0.2);
}

.pf-popup-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

/* Информация об оценке в попапе */
.pf-grade-info-detailed {
  padding: 30px 40px;
}

.pf-grade-main-info {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 40px;
  padding: 30px;
  background: linear-gradient(135deg, rgba(0, 47, 167, 0.03) 0%, rgba(255, 255, 255, 0.8) 100%);
  border-radius: 20px;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-grade-circle-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.pf-grade-circle-large:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);
}

.pf-grade-number-large {
  font-size: 2.5rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.pf-grade-basic-details {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.pf-detail-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pf-detail-label {
  font-size: 0.9rem;
  color: #718096;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.pf-detail-value {
  font-size: 1.1rem;
  color: #011f6d;
  font-weight: 600;
}

/* Вкладки */
.pf-mark-tabs {
  display: flex;
  background: rgba(0, 47, 167, 0.05);
  border-radius: 15px;
  padding: 6px;
  margin-bottom: 30px;
  gap: 4px;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-mark-tab {
  padding: 15px 25px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #718096;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1 1;
  text-align: center;
  font-size: 0.95rem;
}

.pf-mark-tab:hover {
  color: #002FA7;
  background: rgba(255, 255, 255, 0.8);
  transform: translateY(-2px);
}

.pf-mark-tab.pf-active {
  background: white;
  color: #002FA7;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.2);
  font-weight: 600;
}

.pf-mark-tab-content {
  min-height: 400px;
  animation: pf-fadeIn 0.3s ease;
}

/* Информационная сетка */
.pf-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.pf-info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 25px;
  background: rgba(0, 47, 167, 0.03);
  border-radius: 15px;
  border: 1px solid rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
}

.pf-info-item:hover {
  border-color: rgba(0, 47, 167, 0.3);
  background: rgba(0, 47, 167, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);
}

.pf-info-label {
  font-weight: 600;
  color: #002FA7;
}

.pf-info-fullwidth {
  grid-column: 1 / -1;
}

.pf-info-comment {
  background: white;
  padding: 20px;
  border-radius: 12px;
  display: block;
  margin-top: 12px;
  border: 1px solid #e2e8f0;
  line-height: 1.6;
  font-weight: 500;
  color: #4a5568;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* Файлы */
.pf-lesson-files,
.pf-comment-files-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  width: 100%;
}

.pf-lesson-file-item,
.pf-comment-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  width: 100%;
}

.pf-lesson-file-item:hover,
.pf-comment-file-item:hover {
  border-color: rgba(0, 47, 167, 0.3);
  background: #fafbff;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);
}

.pf-lesson-file-info,
.pf-comment-file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.pf-lesson-file-icon,
.pf-comment-file-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 47, 167, 0.1);
  border-radius: 10px;
}

.pf-comment-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pf-lesson-file-name,
.pf-comment-file-name {
  font-size: 0.9rem;
  color: #374151;
  font-weight: 500;
  word-break: break-all;
  padding-right: 12px;
}

.pf-lesson-file-actions,
.pf-comment-file-actions {
  display: flex;
  gap: 10px;
}

/* Кнопки действий с файлами */
.pf-preview-file-btn,
.pf-download-file-btn {
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  min-width: 44px;
  min-height: 34px;
  justify-content: center;
}

.pf-preview-file-btn {
  background: rgba(34, 197, 94, 0.1);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.pf-preview-file-btn:hover {
  background: #16a34a;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
}

.pf-download-file-btn {
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
  border: 1px solid rgba(0, 47, 167, 0.2);
}

.pf-download-file-btn:hover {
  background: #002FA7;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

/* Ссылки на файлы в комментариях */
.pf-comment-file-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(0, 47, 167, 0.05);
  border: 1px solid rgba(0, 47, 167, 0.15);
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  color: #002FA7;
  text-decoration: none;
  margin: 4px;
}

.pf-comment-file-link:hover {
  background: rgba(0, 47, 167, 0.1);
  border-color: rgba(0, 47, 167, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

.pf-comment-file-link .pf-file-icon {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pf-comment-file-link .pf-file-name {
  color: #2d3748;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

/* Адаптивность для мобильных */
@media (max-width: 768px) {
  .pf-comment-file-link {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
  
  .pf-comment-file-link .pf-file-name {
    max-width: 150px;
  }
}

@media (max-width: 480px) {
  .pf-comment-file-link {
    width: 100%;
    justify-content: flex-start;
  }
  
  .pf-comment-file-link .pf-file-name {
    max-width: none;
    white-space: normal;
    word-break: break-all;
  }
}

/* Комментарии */
.pf-comments-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 40px;
}

.pf-comment-item,
.pf-grade-comment-item {
  padding: 30px;
  background: rgba(0, 47, 167, 0.03);
  border-radius: 20px;
  border: 1px solid rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
}

.pf-comment-item:hover,
.pf-grade-comment-item:hover {
  border-color: rgba(0, 47, 167, 0.3);
  background: rgba(0, 47, 167, 0.05);
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 47, 167, 0.1);
}

.pf-comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 15px;
}

.pf-comment-author {
  font-weight: 600;
  color: #002FA7;
  font-size: 1rem;
  background: rgba(0, 47, 167, 0.05);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.pf-comment-date {
  font-size: 0.9rem;
  color: #718096;
  font-weight: 500;
  margin-left: 14px;
}

.pf-comment-action {
  font-weight: 400;
  color: #002FA7;
  font-size: 0.85rem;
  background: rgba(0, 47, 167, 0.05);
  padding: 6px 16px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.pf-comment-content,
.pf-comment-text {
  padding: 20px;
  background: white;
  border-radius: 15px;
  border: 1px solid #e2e8f0;
  color: #2d3748;
  line-height: 1.6;
  margin: 16px 0;
  font-size: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.pf-comment-files {
  margin-top: 20px;
}

.pf-comment-files-title {
  font-size: 0/8rem;
  color: #4a5568;
  font-weight: 500;
  margin: 15px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Меню комментария */
.pf-comment-menu {
  position: relative;
}

.pf-comment-menu-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.pf-comment-menu-btn:hover {
  background-color: #f3f4f6;
}

.pf-comment-menu-dots {
  font-size: 1.2rem;
  font-weight: bold;
  color: #6b7280;
  line-height: 1;
}

.pf-comment-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 120px;
}

.pf-comment-dropdown-item {
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pf-comment-dropdown-item:hover {
  background-color: #f3f4f6;
}

.pf-delete-item {
  color: #dc2626;
}

.pf-delete-item:hover {
  background-color: #fef2f2;
}

/* Изменение оценки */
.pf-comment-grade-change {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid rgba(0, 47, 167, 0.1);
}

.pf-grade-change-label {
  font-size: 0.95rem;
  color: #718096;
  font-weight: 500;
}

.pf-grade-change-value {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 1.1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.pf-grade-change-value:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* Формы комментариев */
.pf-add-comment-form,
.pf-edit-comment-form {
  background: rgba(0, 47, 167, 0.03);
  border-radius: 20px;
  border: 2px dashed rgba(0, 47, 167, 0.2);
  padding: 30px;
  margin-top: 30px;
  animation: pf-slideIn 0.4s ease;
}

@keyframes pf-slideIn {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}

.pf-add-comment-form h4,
.pf-edit-comment-form h4 {
  margin: 0 0 25px 0;
  color: #002FA7;
  font-size: 1.3rem;
  font-weight: 600;
  text-align: center;
}

.pf-comment-textarea {
  width: 100%;
  padding: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 15px;
  resize: vertical;
  min-height: 140px;
  font-family: inherit;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
  line-height: 1.5;
  margin-bottom: 12px;
}

.pf-comment-textarea:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
  background: #fafbff;
}

.pf-file-upload-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.pf-upload-file-btn {
  padding: 14px 25px;
  background: rgba(0, 47, 167, 0.08);
  border: 1px solid rgba(0, 47, 167, 0.3);
  border-radius: 15px;
  color: #002FA7;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 1rem;
}

.pf-upload-file-btn:hover {
  background: rgba(0, 47, 167, 0.15);
  border-color: rgba(0, 47, 167, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);
}

.pf-uploaded-files {
  background: white;
  border-radius: 15px;
  border: 1px solid #e2e8f0;
  padding: 25px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.pf-uploaded-files h5 {
  margin: 0 0 20px 0;
  color: #002FA7;
  font-size: 1rem;
  font-weight: 500;
}

.pf-uploaded-file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background: #f8fafc;
  border-radius: 10px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

.pf-uploaded-file:last-child {
  margin-bottom: 0;
}

.pf-uploaded-file:hover {
  border-color: #cbd5e0;
}

.pf-remove-file-btn {
  background: none;
  border: none;
  color: #e53e3e;
  cursor: pointer;
  font-size: 1.4rem;
  padding: 6px 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pf-remove-file-btn:hover {
  background: #fed7d7;
  transform: scale(1.1);
}

.pf-comment-actions {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 25px;
}

.pf-cancel-comment-btn {
  padding: 10px 42px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  color: #718096;
  cursor: pointer;
  font-weight: 400;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.pf-cancel-comment-btn:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
  color: #4a5568;
  transform: translateY(-2px);
}

.pf-submit-comment-btn {
  padding: 10px 42px;
  background: linear-gradient(135deg, #002FA7 0%, #1e40af 100%);
  border: none;
  border-radius: 12px;
  color: white;
  cursor: pointer;
  font-weight: 400;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);
  font-size: 1rem;
}

.pf-submit-comment-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #1e40af 0%, #002FA7 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.4);
}

.pf-submit-comment-btn:disabled {
  background: #a0aec0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Кнопка добавления комментария */
.pf-add-comment-btn {
  background: linear-gradient(135deg, #002FA7 0%, #1e40af 100%);
  color: white;
  border: none;
  padding: 16px 42px;
  border-radius: 15px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(0, 47, 167, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 40px auto 0;
  width: fit-content;
  min-width: 250px;
}

.pf-add-comment-btn:hover {
  background: linear-gradient(135deg, #1e40af 0%, #002FA7 100%);
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 47, 167, 0.4);
}

/* Состояния */
.pf-no-mark-info,
.pf-no-comments,
.pf-no-comments-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 40px;
  color: #718096;
  text-align: center;
  background: rgba(0, 47, 167, 0.02);
  border-radius: 20px;
  border: 2px dashed rgba(0, 47, 167, 0.1);
}

.pf-no-comments-message p {
  margin: 0;
  font-size: 1.1rem;
}

.pf-loading-small {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 40px;
  color: #718096;
  text-align: center;
  background: rgba(0, 47, 167, 0.02);
  border-radius: 20px;
  border: 2px dashed rgba(0, 47, 167, 0.1);
}

.pf-loading-small .pf-loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 47, 167, 0.2);
  border-left: 4px solid #002FA7;
  border-radius: 50%;
  animation: pf-spin 1s linear infinite;
  margin-bottom: 25px;
}

.pf-loading-small p {
  font-size: 1.1rem;
  font-weight: 600;
  color: #4a5568;
  margin: 0;
}

/* Аккордеон */
.pf-grades-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.pf-grade-accordion-item {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
}

.pf-grade-accordion-item:hover {
  box-shadow: 0 8px 30px rgba(0, 47, 167, 0.12);
  border-color: rgba(0, 47, 167, 0.2);
}

.pf-grade-accordion-header {
  padding: 16px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

.pf-grade-accordion-header:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
}

.pf-grade-accordion-header.pf-expanded {
  background: linear-gradient(135deg, #f1f5f9 0%, #ffffff 100%);
  border-bottom: 1px solid rgba(0, 47, 167, 0.1);
}

.pf-grade-header-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.pf-grade-main {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
}

.pf-grade-value-small {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.pf-grade-accordion-header:hover .pf-grade-value-small {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.pf-grade-title {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pf-grade-topic {
  font-weight: 600;
  color: #2d3748;
  font-size: 1.1rem;
  line-height: 1.3;
}

.pf-grade-date {
  font-size: 0.9rem;
  color: #718096;
  background: rgba(0, 47, 167, 0.05);
  padding: 4px 12px;
  border-radius: 20px;
  display: inline-block;
  width: fit-content;
  font-weight: 500;
}

.pf-grade-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pf-expand-btn,
.pf-detail-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(0, 47, 167, 0.08);
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #002FA7;
  transition: all 0.3s ease;
}

.pf-expand-btn:hover,
.pf-detail-btn:hover {
  background: rgba(0, 47, 167, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);
}

.pf-expand-icon {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 16px;
  font-weight: 600;
  transform: rotate(270deg);
  margin-left: 4px;
}

.pf-expand-icon.pf-rotated {
  transform: rotate(90deg);
  margin-right: 8px;
}

.pf-detail-icon {
  width: 20px;
  height: 20px;
}

.pf-grade-accordion-content {
  padding: 24px;
  background: linear-gradient(135deg, rgba(0, 47, 167, 0.02) 0%, rgba(255, 255, 255, 0.8) 100%);
  border-top: 1px solid rgba(0, 47, 167, 0.1);
}

/* Утилиты */
.pf-text-center {
  text-align: center;
}

.pf-text-left {
  text-align: left;
}

.pf-text-right {
  text-align: right;
}

.pf-mb-20 {
  margin-bottom: 20px;
}

.pf-mt-20 {
  margin-top: 20px;
}

.pf-p-20 {
  padding: 20px;
}

.pf-hidden {
  display: none;
}

.pf-visible {
  display: block;
}

.pf-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pf-fade-in {
  animation: pf-fadeIn 0.5s ease;
}

/* Кастомный скроллбар */
.pf-custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.pf-custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.pf-custom-scrollbar::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.pf-custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Адаптивность */
@media (max-width: 768px) {
  .pf-nav {
    flex-direction: column;
    padding: 0 20px;
  }
  
  .pf-nav-btn {
    width: 100%;
  }
  
  .pf-content {
    padding: 0 20px 20px;
  }
  
  .pf-controls-section {
    flex-direction: column;
    gap: 15px;
    padding: 0 20px;
    margin-left: 0;
  }
  
  .pf-controls-section-left {
    margin-right: 0;
    width: 100%;
    justify-content: center;
  }
  
  .pf-subjects-grid {
    grid-template-columns: 1fr;
  }
  
  .pf-charts-grid {
    grid-template-columns: 1fr;
  }
  
  .pf-stats-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .pf-analytics-top-row {
    flex-direction: column;
  }
  
  .pf-chart-half,
  .pf-stats-vertical {
    width: 100%;
  }
  
  .pf-stats-vertical {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .pf-stats-vertical .pf-stat-card {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 10px);
    min-width: 120px;
  }
  
  .pf-popup-large {
    width: 95%;
    max-height: 95vh;
    border-radius: 15px;
  }
  
  .pf-popup-header {
    padding: 20px 25px 15px;
  }
  
  .pf-grade-info-detailed {
    padding: 20px 25px;
  }
  
  .pf-grade-main-info {
    flex-direction: column;
    text-align: center;
    gap: 25px;
    padding: 25px;
  }
  
  .pf-grade-circle-large {
    width: 80px;
    height: 80px;
    align-self: center;
  }
  
  .pf-mark-tabs {
    flex-wrap: wrap;
  }
  
  .pf-mark-tab {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
    min-width: 120px;
    padding: 12px 16px;
  }
  
  .pf-info-grid {
    grid-template-columns: 1fr;
  }
  
  .pf-comment-file-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .pf-comment-file-actions {
    align-self: stretch;
    justify-content: space-between;
  }
  
  .pf-comment-actions {
    flex-direction: column;
  }
  
  .pf-grade-header-info {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .pf-grade-actions {
    align-self: flex-end;
    margin-top: 8px;
  }
  
  .pf-grade-main {
    width: 100%;
  }
  
  .pf-subjects-table-container {
    overflow-x: auto;
  }
  
  .pf-subjects-table {
    min-width: 600px;
  }
}

@media (max-width: 480px) {
  .pf-stats-cards {
    grid-template-columns: 1fr;
  }
  
  .pf-stats-vertical {
    flex-direction: column;
  }
  
  .pf-stats-vertical .pf-stat-card {
    width: 100%;
  }
  
  .pf-subject-meta {
    flex-direction: column;
    gap: 10px;
  }
  
  .pf-semester-buttons {
    flex-direction: column;
  }
  
  .pf-popup-overlay {
    padding: 10px;
  }
  
  .pf-popup-large {
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }
  
  .pf-popup-header {
    padding: 15px 20px;
  }
  
  .pf-popup-close {
    width: 36px;
    height: 36px;
    font-size: 24px;
  }
  
  .pf-grade-circle-large {
    width: 70px;
    height: 70px;
  }
  
  .pf-grade-number-large {
    font-size: 1.8rem;
  }
  
  .pf-mark-tab {
    flex: 1 1 100%;
    padding: 10px 12px;
  }
  
  .pf-add-comment-btn {
    min-width: 200px;
    padding: 16px 24px;
  }
  
  .pf-table th,
  .pf-table td {
    padding: 12px 8px;
    font-size: 12px;
  }
}

/* Специфичные классы */
.at-teacher-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 47, 167, 0.1);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85em;
  color: #002FA7;
  white-space: nowrap;
}

.pf-semester-hint {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.pf-semester-hint p {
  color: #475569;
  font-size: 0.875rem;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/st-components/PerformanceSectionStyle.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6FAA6F;EAC7F,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,UAAU;AACV;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,WAAW;AACb;;AAEA;;EAEE,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA,8BAA8B;AAC9B;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;;EAEE,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;;EAEE,kCAAkC;EAClC,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,cAAc;AACd;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6FAA6F;EAC7F,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX","sourcesContent":["/* Основные стили */\n.pf-performance-section {\n  min-height: 50vh;\n  background: white;\n  font-family: 'Montserrat', sans-serif !important;\n  color: #1f2937;\n}\n\n/* Загрузка */\n.pf-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  color: #002FA7;\n}\n\n.pf-loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(0, 47, 167, 0.3);\n  border-left: 4px solid #002FA7;\n  border-radius: 50%;\n  animation: pf-spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes pf-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.pf-loading p {\n  font-size: 18px;\n  margin: 0;\n}\n\n/* Навигация */\n.pf-nav {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.pf-nav-btn {\n  padding: 15px 30px;\n  border: none;\n  border-radius: 15px;\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1em;\n  width: 30%;\n}\n\n.pf-nav-btn:hover {\n  background: rgba(0, 47, 167, 0.2);\n  transform: translateY(-2px);\n}\n\n.pf-nav-btn.pf-active {\n  background: #002FA7;\n  color: white;\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.3);\n}\n\n/* Кнопка обновления */\n.pf-refresh-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n}\n\n.pf-refresh-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.pf-refresh-btn:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.pf-refresh-icon {\n  width: 24px;\n  height: 24px;\n  transition: transform 0.3s ease;\n}\n\n.pf-refresh-spin {\n  animation: pf-spin 1s linear infinite;\n}\n\n/* Контролы */\n.pf-controls-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 24px;\n  margin-left: 34px;\n  flex-wrap: wrap;\n}\n\n.pf-controls-section-left {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-right: 34px;\n  flex-wrap: wrap;\n}\n\n/* Селектор семестра */\n.pf-semester-selector {\n  display: flex;\n  gap: 10px;\n}\n\n.pf-semester-buttons {\n  display: flex;\n  background: rgba(0, 47, 167, 0.1);\n  border-radius: 15px;\n  padding: 5px;\n  gap: 5px;\n}\n\n.pf-semester-btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #6c757d;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pf-semester-btn.pf-active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);\n}\n\n/* Переключение вида */\n.pf-view-toggle {\n  display: flex;\n  background: rgba(0, 47, 167, 0.1);\n  border-radius: 12px;\n  padding: 4px;\n  gap: 4px;\n}\n\n.pf-toggle-btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #6c757d;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pf-toggle-btn.pf-active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);\n}\n\n/* Основной контент */\n.pf-content {\n  padding: 0 25px 25px;\n}\n\n.pf-tab-content {\n  animation: pf-fadeIn 0.5s ease;\n}\n\n@keyframes pf-fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Сетка предметов */\n.pf-subjects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 25px;\n  margin-bottom: 40px;\n}\n\n.pf-subject-card {\n  background: white;\n  border-radius: 20px;\n  padding: 25px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-subject-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);\n  border-color: rgba(0, 47, 167, 0.3);\n}\n\n.pf-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.pf-subject-title {\n  margin: 0;\n  font-size: 1.3em;\n  font-weight: 600;\n  color: #2d3748;\n  line-height: 1.3;\n  text-align: left;\n}\n\n/* Общие стили для оценок */\n.pf-preview-grade,\n.pf-stack-grade,\n.pf-grade-value,\n.pf-session-grade,\n.pf-grade-value-small,\n.pf-grade-change-value {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.pf-preview-grade,\n.pf-grade-value,\n.pf-session-grade,\n.pf-grade-value-small {\n  width: 35px;\n  height: 35px;\n  border-radius: 10px;\n  font-size: 0.9em;\n}\n\n.pf-stack-grade {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  font-size: 0.85em;\n}\n\n.pf-preview-grade:hover,\n.pf-stack-grade:hover,\n.pf-grade-value:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.pf-preview-grade.pf-no-data,\n.pf-stack-grade.pf-no-data,\n.pf-grade-value.pf-no-data,\n.pf-grade-value-small.pf-no-data {\n  background-color: #d1d5db !important;\n}\n\n.pf-grades-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 20px;\n  min-height: 40px;\n  align-items: center;\n}\n\n.pf-more-grades {\n  background: #e2e8f0;\n  color: #64748b;\n  padding: 8px 12px;\n  border-radius: 10px;\n  font-size: 0.8em;\n  font-weight: 500;\n}\n\n.pf-no-grades,\n.pf-no-data-text {\n  color: #a0aec0;\n  font-style: italic;\n  font-size: 0.9em;\n}\n\n/* Футер карточки */\n.pf-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 15px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.pf-average-score {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pf-average-label {\n  font-size: 0.9em;\n  color: #718096;\n}\n\n.pf-average-value {\n  font-weight: 700;\n  font-size: 1.1em;\n}\n\n/* Таблица предметов */\n.pf-subjects-table-container {\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-subjects-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.pf-subjects-table th {\n  background: rgba(0, 47, 167, 0.05);\n  padding: 20px;\n  text-align: left;\n  font-weight: 600;\n  color: #4a5568;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.pf-subjects-table td {\n  padding: 20px;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.pf-subjects-table tr:hover {\n  background: rgba(0, 47, 167, 0.02);\n}\n\n.pf-subject-cell {\n  width: 25%;\n  text-align: left;\n}\n\n.pf-subject-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pf-subject-name {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 1rem;\n}\n\n.pf-subject-teacher {\n  font-size: 0.9rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.pf-grades-cell {\n  width: 45%;\n}\n\n.pf-grades-stack {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.pf-average-cell {\n  width: 15%;\n}\n\n.pf-average-badge {\n  padding: 8px 16px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.9em;\n  text-align: center;\n  min-width: 60px;\n}\n\n.pf-session-cell {\n  width: 15%;\n}\n\n.pf-session-grade {\n  margin: 0 auto;\n}\n\n/* Аналитика */\n.pf-analytics-container {\n  background: white;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-analytics-top-row {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 30px;\n  align-items: stretch;\n}\n\n.pf-chart-half {\n  flex: 2;\n  min-width: 0;\n}\n\n/* Карточки статистики */\n.pf-stats-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.pf-stats-vertical {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin: 0;\n}\n\n.pf-stat-card {\n  background: rgba(0, 47, 167, 0.08);\n  color: #002FA7;\n  padding: 25px;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);\n  background: rgba(0, 47, 167, 0.12);\n}\n\n.pf-stat-content {\n  text-align: center;\n}\n\n.pf-stat-content .pf-stat-value {\n  font-size: 2.5em;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1;\n  color: #002FA7;\n}\n\n.pf-stat-content .pf-stat-label {\n  font-size: 1em;\n  color: #002FA7;\n  margin: 8px 0 0 0;\n  font-weight: 500;\n  opacity: 0.9;\n}\n\n/* Графики */\n.pf-charts-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 30px;\n  margin-top: 20px;\n}\n\n.pf-chart-card {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  max-width: 100%;\n}\n\n.pf-chart-card h3 {\n  margin: 0 0 25px 0;\n  color: #2d3748;\n  font-size: 1.3em;\n  font-weight: 600;\n  text-align: center;\n}\n\n.pf-chart-card p {\n  color: #a8aaad;\n  font-size: 10px;\n  margin: 0;\n}\n\n/* Детали предмета */\n.pf-subject-detail-container {\n  background: white;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-subject-selector {\n  margin-bottom: 30px;\n}\n\n.pf-select {\n  width: 100%;\n  padding: 15px 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1em;\n  background: white;\n  color: #4a5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pf-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.pf-detail-header {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f7fafc;\n}\n\n.pf-detail-header h2 {\n  margin: 0 0 15px 0;\n  color: #2d3748;\n  font-size: 1.8em;\n  font-weight: 700;\n}\n\n.pf-subject-meta {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.pf-meta-item {\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.9em;\n  font-weight: 500;\n}\n\n/* Состояние без выбранного предмета */\n.pf-no-subject-selected,\n.pf-no-data-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  width: 100%;\n}\n\n.pf-empty-state {\n  text-align: center;\n  padding: 2rem;\n  max-width: 400px;\n}\n\n.pf-empty-state h3 {\n  color: #64748b;\n  margin-bottom: 0.5rem;\n}\n\n.pf-empty-state p {\n  color: #94a3b8;\n  margin-bottom: 1rem;\n  font-size: 1.1em;\n}\n\n/* Попап */\n.pf-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  animation: pf-modal-fade-in 0.3s ease;\n  backdrop-filter: blur(4px);\n}\n\n@keyframes pf-modal-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.pf-popup-large {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\n  width: 90%;\n  max-width: 900px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: pf-scaleIn 0.3s ease;\n}\n\n@keyframes pf-scaleIn {\n  from { opacity: 0; transform: scale(0.9); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.pf-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 40px 20px;\n  border-bottom: 1px solid rgba(0, 47, 167, 0.1);\n  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);\n  border-radius: 20px 20px 0 0;\n}\n\n.pf-popup-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.pf-popup-close {\n  background: rgba(0, 47, 167, 0.1);\n  border: none;\n  border-radius: 4px;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #002FA7;\n  font-size: 28px;\n  font-weight: 300;\n}\n\n.pf-popup-close:hover {\n  background: rgba(0, 47, 167, 0.2);\n}\n\n.pf-popup-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n/* Информация об оценке в попапе */\n.pf-grade-info-detailed {\n  padding: 30px 40px;\n}\n\n.pf-grade-main-info {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  margin-bottom: 40px;\n  padding: 30px;\n  background: linear-gradient(135deg, rgba(0, 47, 167, 0.03) 0%, rgba(255, 255, 255, 0.8) 100%);\n  border-radius: 20px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-grade-circle-large {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 4px solid;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  transition: all 0.3s ease;\n}\n\n.pf-grade-circle-large:hover {\n  transform: scale(1.05);\n  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);\n}\n\n.pf-grade-number-large {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.pf-grade-basic-details {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.pf-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pf-detail-label {\n  font-size: 0.9rem;\n  color: #718096;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.pf-detail-value {\n  font-size: 1.1rem;\n  color: #011f6d;\n  font-weight: 600;\n}\n\n/* Вкладки */\n.pf-mark-tabs {\n  display: flex;\n  background: rgba(0, 47, 167, 0.05);\n  border-radius: 15px;\n  padding: 6px;\n  margin-bottom: 30px;\n  gap: 4px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-mark-tab {\n  padding: 15px 25px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #718096;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex: 1;\n  text-align: center;\n  font-size: 0.95rem;\n}\n\n.pf-mark-tab:hover {\n  color: #002FA7;\n  background: rgba(255, 255, 255, 0.8);\n  transform: translateY(-2px);\n}\n\n.pf-mark-tab.pf-active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.2);\n  font-weight: 600;\n}\n\n.pf-mark-tab-content {\n  min-height: 400px;\n  animation: pf-fadeIn 0.3s ease;\n}\n\n/* Информационная сетка */\n.pf-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.pf-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 25px;\n  background: rgba(0, 47, 167, 0.03);\n  border-radius: 15px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n}\n\n.pf-info-item:hover {\n  border-color: rgba(0, 47, 167, 0.3);\n  background: rgba(0, 47, 167, 0.05);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.1);\n}\n\n.pf-info-label {\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.pf-info-fullwidth {\n  grid-column: 1 / -1;\n}\n\n.pf-info-comment {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  display: block;\n  margin-top: 12px;\n  border: 1px solid #e2e8f0;\n  line-height: 1.6;\n  font-weight: 500;\n  color: #4a5568;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n/* Файлы */\n.pf-lesson-files,\n.pf-comment-files-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n  width: 100%;\n}\n\n.pf-lesson-file-item,\n.pf-comment-file-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: white;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  width: 100%;\n}\n\n.pf-lesson-file-item:hover,\n.pf-comment-file-item:hover {\n  border-color: rgba(0, 47, 167, 0.3);\n  background: #fafbff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);\n}\n\n.pf-lesson-file-info,\n.pf-comment-file-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.pf-lesson-file-icon,\n.pf-comment-file-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 47, 167, 0.1);\n  border-radius: 10px;\n}\n\n.pf-comment-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pf-lesson-file-name,\n.pf-comment-file-name {\n  font-size: 0.9rem;\n  color: #374151;\n  font-weight: 500;\n  word-break: break-all;\n  padding-right: 12px;\n}\n\n.pf-lesson-file-actions,\n.pf-comment-file-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* Кнопки действий с файлами */\n.pf-preview-file-btn,\n.pf-download-file-btn {\n  padding: 10px 16px;\n  border: none;\n  border-radius: 10px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  min-width: 44px;\n  min-height: 34px;\n  justify-content: center;\n}\n\n.pf-preview-file-btn {\n  background: rgba(34, 197, 94, 0.1);\n  color: #16a34a;\n  border: 1px solid rgba(34, 197, 94, 0.2);\n}\n\n.pf-preview-file-btn:hover {\n  background: #16a34a;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);\n}\n\n.pf-download-file-btn {\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n  border: 1px solid rgba(0, 47, 167, 0.2);\n}\n\n.pf-download-file-btn:hover {\n  background: #002FA7;\n  color: white;\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n/* Ссылки на файлы в комментариях */\n.pf-comment-file-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: rgba(0, 47, 167, 0.05);\n  border: 1px solid rgba(0, 47, 167, 0.15);\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  color: #002FA7;\n  text-decoration: none;\n  margin: 4px;\n}\n\n.pf-comment-file-link:hover {\n  background: rgba(0, 47, 167, 0.1);\n  border-color: rgba(0, 47, 167, 0.3);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n.pf-comment-file-link .pf-file-icon {\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pf-comment-file-link .pf-file-name {\n  color: #2d3748;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n/* Адаптивность для мобильных */\n@media (max-width: 768px) {\n  .pf-comment-file-link {\n    padding: 6px 12px;\n    font-size: 0.85rem;\n  }\n  \n  .pf-comment-file-link .pf-file-name {\n    max-width: 150px;\n  }\n}\n\n@media (max-width: 480px) {\n  .pf-comment-file-link {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .pf-comment-file-link .pf-file-name {\n    max-width: none;\n    white-space: normal;\n    word-break: break-all;\n  }\n}\n\n/* Комментарии */\n.pf-comments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  margin-bottom: 40px;\n}\n\n.pf-comment-item,\n.pf-grade-comment-item {\n  padding: 30px;\n  background: rgba(0, 47, 167, 0.03);\n  border-radius: 20px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n}\n\n.pf-comment-item:hover,\n.pf-grade-comment-item:hover {\n  border-color: rgba(0, 47, 167, 0.3);\n  background: rgba(0, 47, 167, 0.05);\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(0, 47, 167, 0.1);\n}\n\n.pf-comment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.pf-comment-author {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 1rem;\n  background: rgba(0, 47, 167, 0.05);\n  padding: 8px 16px;\n  border-radius: 20px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pf-comment-date {\n  font-size: 0.9rem;\n  color: #718096;\n  font-weight: 500;\n  margin-left: 14px;\n}\n\n.pf-comment-action {\n  font-weight: 400;\n  color: #002FA7;\n  font-size: 0.85rem;\n  background: rgba(0, 47, 167, 0.05);\n  padding: 6px 16px;\n  border-radius: 20px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pf-comment-content,\n.pf-comment-text {\n  padding: 20px;\n  background: white;\n  border-radius: 15px;\n  border: 1px solid #e2e8f0;\n  color: #2d3748;\n  line-height: 1.6;\n  margin: 16px 0;\n  font-size: 1rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.pf-comment-files {\n  margin-top: 20px;\n}\n\n.pf-comment-files-title {\n  font-size: 0/8rem;\n  color: #4a5568;\n  font-weight: 500;\n  margin: 15px 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Меню комментария */\n.pf-comment-menu {\n  position: relative;\n}\n\n.pf-comment-menu-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.pf-comment-menu-btn:hover {\n  background-color: #f3f4f6;\n}\n\n.pf-comment-menu-dots {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #6b7280;\n  line-height: 1;\n}\n\n.pf-comment-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  min-width: 120px;\n}\n\n.pf-comment-dropdown-item {\n  width: 100%;\n  padding: 8px 12px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pf-comment-dropdown-item:hover {\n  background-color: #f3f4f6;\n}\n\n.pf-delete-item {\n  color: #dc2626;\n}\n\n.pf-delete-item:hover {\n  background-color: #fef2f2;\n}\n\n/* Изменение оценки */\n.pf-comment-grade-change {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 2px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-grade-change-label {\n  font-size: 0.95rem;\n  color: #718096;\n  font-weight: 500;\n}\n\n.pf-grade-change-value {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 1.1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.pf-grade-change-value:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Формы комментариев */\n.pf-add-comment-form,\n.pf-edit-comment-form {\n  background: rgba(0, 47, 167, 0.03);\n  border-radius: 20px;\n  border: 2px dashed rgba(0, 47, 167, 0.2);\n  padding: 30px;\n  margin-top: 30px;\n  animation: pf-slideIn 0.4s ease;\n}\n\n@keyframes pf-slideIn {\n  from { opacity: 0; transform: translateX(-20px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n.pf-add-comment-form h4,\n.pf-edit-comment-form h4 {\n  margin: 0 0 25px 0;\n  color: #002FA7;\n  font-size: 1.3rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.pf-comment-textarea {\n  width: 100%;\n  padding: 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 15px;\n  resize: vertical;\n  min-height: 140px;\n  font-family: inherit;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: white;\n  line-height: 1.5;\n  margin-bottom: 12px;\n}\n\n.pf-comment-textarea:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n  background: #fafbff;\n}\n\n.pf-file-upload-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.pf-upload-file-btn {\n  padding: 14px 25px;\n  background: rgba(0, 47, 167, 0.08);\n  border: 1px solid rgba(0, 47, 167, 0.3);\n  border-radius: 15px;\n  color: #002FA7;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  font-size: 1rem;\n}\n\n.pf-upload-file-btn:hover {\n  background: rgba(0, 47, 167, 0.15);\n  border-color: rgba(0, 47, 167, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);\n}\n\n.pf-uploaded-files {\n  background: white;\n  border-radius: 15px;\n  border: 1px solid #e2e8f0;\n  padding: 25px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.pf-uploaded-files h5 {\n  margin: 0 0 20px 0;\n  color: #002FA7;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.pf-uploaded-file {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  background: #f8fafc;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  transition: all 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.pf-uploaded-file:last-child {\n  margin-bottom: 0;\n}\n\n.pf-uploaded-file:hover {\n  border-color: #cbd5e0;\n}\n\n.pf-remove-file-btn {\n  background: none;\n  border: none;\n  color: #e53e3e;\n  cursor: pointer;\n  font-size: 1.4rem;\n  padding: 6px 10px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pf-remove-file-btn:hover {\n  background: #fed7d7;\n  transform: scale(1.1);\n}\n\n.pf-comment-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-end;\n  margin-top: 25px;\n}\n\n.pf-cancel-comment-btn {\n  padding: 10px 42px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  color: #718096;\n  cursor: pointer;\n  font-weight: 400;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.pf-cancel-comment-btn:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n  color: #4a5568;\n  transform: translateY(-2px);\n}\n\n.pf-submit-comment-btn {\n  padding: 10px 42px;\n  background: linear-gradient(135deg, #002FA7 0%, #1e40af 100%);\n  border: none;\n  border-radius: 12px;\n  color: white;\n  cursor: pointer;\n  font-weight: 400;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);\n  font-size: 1rem;\n}\n\n.pf-submit-comment-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #1e40af 0%, #002FA7 100%);\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.4);\n}\n\n.pf-submit-comment-btn:disabled {\n  background: #a0aec0;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Кнопка добавления комментария */\n.pf-add-comment-btn {\n  background: linear-gradient(135deg, #002FA7 0%, #1e40af 100%);\n  color: white;\n  border: none;\n  padding: 16px 42px;\n  border-radius: 15px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 6px 20px rgba(0, 47, 167, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin: 40px auto 0;\n  width: fit-content;\n  min-width: 250px;\n}\n\n.pf-add-comment-btn:hover {\n  background: linear-gradient(135deg, #1e40af 0%, #002FA7 100%);\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(0, 47, 167, 0.4);\n}\n\n/* Состояния */\n.pf-no-mark-info,\n.pf-no-comments,\n.pf-no-comments-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 100px 40px;\n  color: #718096;\n  text-align: center;\n  background: rgba(0, 47, 167, 0.02);\n  border-radius: 20px;\n  border: 2px dashed rgba(0, 47, 167, 0.1);\n}\n\n.pf-no-comments-message p {\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.pf-loading-small {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 100px 40px;\n  color: #718096;\n  text-align: center;\n  background: rgba(0, 47, 167, 0.02);\n  border-radius: 20px;\n  border: 2px dashed rgba(0, 47, 167, 0.1);\n}\n\n.pf-loading-small .pf-loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(0, 47, 167, 0.2);\n  border-left: 4px solid #002FA7;\n  border-radius: 50%;\n  animation: pf-spin 1s linear infinite;\n  margin-bottom: 25px;\n}\n\n.pf-loading-small p {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #4a5568;\n  margin: 0;\n}\n\n/* Аккордеон */\n.pf-grades-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.pf-grade-accordion-item {\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n}\n\n.pf-grade-accordion-item:hover {\n  box-shadow: 0 8px 30px rgba(0, 47, 167, 0.12);\n  border-color: rgba(0, 47, 167, 0.2);\n}\n\n.pf-grade-accordion-header {\n  padding: 16px 24px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.pf-grade-accordion-header:hover {\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n}\n\n.pf-grade-accordion-header.pf-expanded {\n  background: linear-gradient(135deg, #f1f5f9 0%, #ffffff 100%);\n  border-bottom: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.pf-grade-header-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.pf-grade-main {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n}\n\n.pf-grade-value-small {\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  font-size: 18px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.pf-grade-accordion-header:hover .pf-grade-value-small {\n  transform: scale(1.05);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n}\n\n.pf-grade-title {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pf-grade-topic {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1.1rem;\n  line-height: 1.3;\n}\n\n.pf-grade-date {\n  font-size: 0.9rem;\n  color: #718096;\n  background: rgba(0, 47, 167, 0.05);\n  padding: 4px 12px;\n  border-radius: 20px;\n  display: inline-block;\n  width: fit-content;\n  font-weight: 500;\n}\n\n.pf-grade-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pf-expand-btn,\n.pf-detail-btn {\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: rgba(0, 47, 167, 0.08);\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #002FA7;\n  transition: all 0.3s ease;\n}\n\n.pf-expand-btn:hover,\n.pf-detail-btn:hover {\n  background: rgba(0, 47, 167, 0.15);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);\n}\n\n.pf-expand-icon {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  font-size: 16px;\n  font-weight: 600;\n  transform: rotate(270deg);\n  margin-left: 4px;\n}\n\n.pf-expand-icon.pf-rotated {\n  transform: rotate(90deg);\n  margin-right: 8px;\n}\n\n.pf-detail-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.pf-grade-accordion-content {\n  padding: 24px;\n  background: linear-gradient(135deg, rgba(0, 47, 167, 0.02) 0%, rgba(255, 255, 255, 0.8) 100%);\n  border-top: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n/* Утилиты */\n.pf-text-center {\n  text-align: center;\n}\n\n.pf-text-left {\n  text-align: left;\n}\n\n.pf-text-right {\n  text-align: right;\n}\n\n.pf-mb-20 {\n  margin-bottom: 20px;\n}\n\n.pf-mt-20 {\n  margin-top: 20px;\n}\n\n.pf-p-20 {\n  padding: 20px;\n}\n\n.pf-hidden {\n  display: none;\n}\n\n.pf-visible {\n  display: block;\n}\n\n.pf-disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pf-fade-in {\n  animation: pf-fadeIn 0.5s ease;\n}\n\n/* Кастомный скроллбар */\n.pf-custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.pf-custom-scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.pf-custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.pf-custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .pf-nav {\n    flex-direction: column;\n    padding: 0 20px;\n  }\n  \n  .pf-nav-btn {\n    width: 100%;\n  }\n  \n  .pf-content {\n    padding: 0 20px 20px;\n  }\n  \n  .pf-controls-section {\n    flex-direction: column;\n    gap: 15px;\n    padding: 0 20px;\n    margin-left: 0;\n  }\n  \n  .pf-controls-section-left {\n    margin-right: 0;\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .pf-subjects-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .pf-charts-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .pf-stats-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .pf-analytics-top-row {\n    flex-direction: column;\n  }\n  \n  .pf-chart-half,\n  .pf-stats-vertical {\n    width: 100%;\n  }\n  \n  .pf-stats-vertical {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  \n  .pf-stats-vertical .pf-stat-card {\n    flex: 1 1 calc(33.333% - 10px);\n    min-width: 120px;\n  }\n  \n  .pf-popup-large {\n    width: 95%;\n    max-height: 95vh;\n    border-radius: 15px;\n  }\n  \n  .pf-popup-header {\n    padding: 20px 25px 15px;\n  }\n  \n  .pf-grade-info-detailed {\n    padding: 20px 25px;\n  }\n  \n  .pf-grade-main-info {\n    flex-direction: column;\n    text-align: center;\n    gap: 25px;\n    padding: 25px;\n  }\n  \n  .pf-grade-circle-large {\n    width: 80px;\n    height: 80px;\n    align-self: center;\n  }\n  \n  .pf-mark-tabs {\n    flex-wrap: wrap;\n  }\n  \n  .pf-mark-tab {\n    flex: 1 1 calc(50% - 8px);\n    min-width: 120px;\n    padding: 12px 16px;\n  }\n  \n  .pf-info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .pf-comment-file-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .pf-comment-file-actions {\n    align-self: stretch;\n    justify-content: space-between;\n  }\n  \n  .pf-comment-actions {\n    flex-direction: column;\n  }\n  \n  .pf-grade-header-info {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .pf-grade-actions {\n    align-self: flex-end;\n    margin-top: 8px;\n  }\n  \n  .pf-grade-main {\n    width: 100%;\n  }\n  \n  .pf-subjects-table-container {\n    overflow-x: auto;\n  }\n  \n  .pf-subjects-table {\n    min-width: 600px;\n  }\n}\n\n@media (max-width: 480px) {\n  .pf-stats-cards {\n    grid-template-columns: 1fr;\n  }\n  \n  .pf-stats-vertical {\n    flex-direction: column;\n  }\n  \n  .pf-stats-vertical .pf-stat-card {\n    width: 100%;\n  }\n  \n  .pf-subject-meta {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .pf-semester-buttons {\n    flex-direction: column;\n  }\n  \n  .pf-popup-overlay {\n    padding: 10px;\n  }\n  \n  .pf-popup-large {\n    width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  \n  .pf-popup-header {\n    padding: 15px 20px;\n  }\n  \n  .pf-popup-close {\n    width: 36px;\n    height: 36px;\n    font-size: 24px;\n  }\n  \n  .pf-grade-circle-large {\n    width: 70px;\n    height: 70px;\n  }\n  \n  .pf-grade-number-large {\n    font-size: 1.8rem;\n  }\n  \n  .pf-mark-tab {\n    flex: 1 1 100%;\n    padding: 10px 12px;\n  }\n  \n  .pf-add-comment-btn {\n    min-width: 200px;\n    padding: 16px 24px;\n  }\n  \n  .pf-table th,\n  .pf-table td {\n    padding: 12px 8px;\n    font-size: 12px;\n  }\n}\n\n/* Специфичные классы */\n.at-teacher-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(0, 47, 167, 0.1);\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.85em;\n  color: #002FA7;\n  white-space: nowrap;\n}\n\n.pf-semester-hint {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.pf-semester-hint p {\n  color: #475569;\n  font-size: 0.875rem;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
